const root = jQuery('.footer__partners__carousel')
const slider = jQuery('.footer__carousel', root)
const slides = jQuery('.footer__logo', slider)

if (slider.length > 0 && slides.length > 1) {
    slider.flickity({
        cellSelector: '.footer__logo',
        autoPlay: true,
        prevNextButtons: false,
        pageDots: false,
        groupCells: true,
        wrapAround: true,
        cellAlign: 'left',
        contain: false,
        draggable: true
    })

    jQuery('.button--previous', root).on('click', function () {
        slider.flickity('previous')
    })

    jQuery('.button--next', root).on('click', function () {
        slider.flickity('next')
    })
}
